import { withFormik } from "formik";
import * as Yup from "yup";

const PrivacyPolicyEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    Privacy_Policy_for: Yup.string().required("please choose section"),
    Privacy_Policy_description: Yup.string().required(
      "please enter description"
    )
  }),
  validateOnMount: true,
  mapPropsToValues: props => ({
    Privacy_Policy_for: "",
    Privacy_Policy_description: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default PrivacyPolicyEnhancer;
